import { useEffect } from 'react';

// Lightweight SEO helper without external deps
// Props: title, description, canonical, ogImage
export default function SEO({ title, description, canonical, ogImage }) {
  useEffect(() => {
    if (title) {
      document.title = title;
      setMeta('og:title', title, true);
      setMeta('twitter:title', title);
    }

    if (description) {
      upsertNamedMeta('description', description);
      setMeta('og:description', description, true);
      setMeta('twitter:description', description);
    }

    const url = canonical || window.location.href;
    setCanonical(url);
    setMeta('og:url', url, true);

    if (ogImage) {
      setMeta('og:image', ogImage, true);
      upsertNamedMeta('twitter:card', 'summary_large_image');
      upsertNamedMeta('twitter:image', ogImage);
    }

    // helper: property vs name meta
    function setMeta(key, value, isOg = false) {
      const selector = isOg ? `meta[property=\"${key}\"]` : `meta[name=\"${key}\"]`;
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement('meta');
        if (isOg) el.setAttribute('property', key); else el.setAttribute('name', key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', value);
    }

    function upsertNamedMeta(name, content) {
      let el = document.head.querySelector(`meta[name=\"${name}\"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    }

    function setCanonical(href) {
      let link = document.head.querySelector('link[rel=\"canonical\"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', href);
    }
  }, [title, description, canonical, ogImage]);

  return null;
}

